import { createBaseApi } from "../baseApi";
import { FilterOptionsSchema } from "model/_base/filters/filter-options.schema";

export const filterOptionsApi = createBaseApi("filter", "/filters").injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    // Get Filter Options
    getFilterOptions: builder.query({
      query: () => {
        return {
          url: "options",
          method: "GET",
        };
      },
      transformResponse: (response) => {
        return FilterOptionsSchema.cast(response.data, {
          stripUnknown: true,
        });
      },
    }),
  }),
});

export const { useGetFilterOptionsQuery } = filterOptionsApi;
